import type { ITreeNode } from '@platform/core/types';

/** Поточна ітерація (прототип v4 curIter, чиста функція): найглибший вузол, у межах дат якого сьогодні; немає — null. */
export function currentIteration(nodes: readonly ITreeNode[], today: string): ITreeNode | null {
  const depth = (n: ITreeNode): number => (n.parentId ? 1 + depth(nodes.find((p) => p.id === n.parentId) ?? { ...n, parentId: null }) : 0);
  const active = nodes.filter((n) => n.startDate && n.endDate && n.startDate <= today && today <= n.endDate);
  return active.sort((a, b) => depth(b) - depth(a))[0] ?? null;
}
